export default __webpack_public_path__ + "static/media/Group 5839.f64b4ac8.svg";